import { GetGenresResponse } from './genres.data-model';
import useSWR from 'swr';

const API_BASE = process.env.API_REVIEWS_BASE;
const ENDPOINT = `${API_BASE}/genres`;

const fetcher = async <T>(url: string, options?: RequestInit): Promise<T> => {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const msg = await res.text();
    throw new Error(msg || `Error ${res.status}`);
  }
  return res.json();
};

export function useGenresList() {
  const {
    data,
    error,
    isLoading,
    mutate: refresh,
  } = useSWR<GetGenresResponse>(ENDPOINT, () =>
    fetcher<GetGenresResponse>(ENDPOINT)
  );

  return {
    genres: data?.items ?? [],
    isLoading,
    isError: !!error,
    refresh,
  };
}
